/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type {
  ICurveMainRegistryLike,
  ICurveMainRegistryLikeInterface,
} from "../ICurveMainRegistryLike";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_pool",
        type: "address",
      },
    ],
    name: "get_coins",
    outputs: [
      {
        internalType: "address[8]",
        name: "",
        type: "address[8]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_lpToken",
        type: "address",
      },
    ],
    name: "get_pool_from_lp_token",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_pool",
        type: "address",
      },
    ],
    name: "is_meta",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

export class ICurveMainRegistryLike__factory {
  static readonly abi = _abi;
  static createInterface(): ICurveMainRegistryLikeInterface {
    return new utils.Interface(_abi) as ICurveMainRegistryLikeInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ICurveMainRegistryLike {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as ICurveMainRegistryLike;
  }
}
